import React, { useEffect } from 'react'
import { AgentCard } from '../components'
import { useState } from 'react'
import services from '../../ioc/services';
import { ModalContainer } from '.';
import AddAdminForm from './Forms/AddAdminForm';


function AdminsContainer() {

    const [admins, setAdmins] = useState([]);

    const [editing, setEditing] = useState(false);

    const [deleting, setDeleting] = useState(false);

    const [editData, setEditData] = useState(null);

    const [deleteData, setDeleteData] = useState(null);

    useEffect(() => {
        services.api.admin.getAdmins().then(res => {
            setAdmins(res)
        });
    }, [])

    const displayhandleAdminEdit = (admin) => {

        const adminEditData = {
            id: admin._id,
            firstName: admin.firstName,
            lastName: admin.lastName,
            email: admin.user.email,
            phoneNumber: admin.phoneNumber,
            location: admin.location ?? "",
        }

        setEditData(adminEditData)

        setEditing(true);

    }

    const displayhandleAdmindelete = (admin) => {

        const adminEditData = {
            id: admin._id,
            user_id: admin.user_id,
            firstName: admin.firstName,
            lastName: admin.lastName,
        }

        setDeleteData(adminEditData)
        setDeleting(true);
    }

    const handleAdminDelete = () => {

        services.api.auth.deleteUser({ user: deleteData.user_id })
            .then(res => {
                services.alert.toast.success("Admin Deleted Successfully");
                window.location.reload();
            })
            .catch(err => services.alert.toast.error(err))
    }

    return (
        <>
            <div className=' grid grid-cols-4 gap-4'>
                {admins.map(admin => <AgentCard
                    agent={admin}
                    key={admin.id}
                    handleEditClick={() => displayhandleAdminEdit(admin)}
                    handleDeleteClick={() => displayhandleAdmindelete(admin)}
                    isAgent={false} />)}
            </div>

            <ModalContainer title="Edit Admin Details" isOpen={editing} setIsOpen={setEditing}>
                <AddAdminForm isEdit={true} adminData={editData} />
            </ModalContainer>

            {deleting && <ModalContainer
                title="Delete Admin"
                isOpen={deleting}
                setIsOpen={setDeleting}
                contentStyle={
                    {
                        maxWidth: '500px',
                        maxHeight: '300px',
                        margin: 'auto',
                    }
                }
            >
                <div>
                    <p className=' text-center'>Are you sure you want to delete  {deleteData.firstName} {deleteData.lastName}?</p>

                    <div className=' grid justify-around grid-cols-2 gap-8 items-center mt-12'>
                        <button
                            onClick={handleAdminDelete}
                            className='bg-red-400 text-white text-sm rounded-lg py-2 px-6'>Yes</button>
                        <button
                            onClick={() => setDeleting(false)}
                            className='bg-slate-500 text-white text-sm rounded-lg py-2 px-6'>No</button>
                    </div>
                </div>

            </ModalContainer>}

        </>

    )
}

export default AdminsContainer